document.addEventListener('DOMContentLoaded', function () {
  // Mobile navigation "open from top (below header)" behavior:
  // - Do not close when clicking outside the drawer
  // - Overlay is made non-interactive via CSS (see yg-style.css)
  (function () {
    const navDrawer = document.getElementById('header-sidebar-menu');
    if (!navDrawer) return;

    // If merchant chose the special "top" opening, disable focus-trap so outside clicks don't force-close the dialog.
    if (navDrawer.getAttribute('mobile-opening') === 'top') {
      // Sync drawer position/size so it starts below header and fills the rest of viewport.
      const getHeader = () => document.querySelector('store-header');
      const getAnnouncement = () => document.querySelector('.shopify-section--announcement-bar');
      const applyLayout = () => {
        if (window.innerWidth >= 1150) {
          navDrawer.style.removeProperty('left');
          navDrawer.style.removeProperty('right');
          navDrawer.style.removeProperty('width');
          navDrawer.style.removeProperty('maxWidth');
          navDrawer.style.removeProperty('height');
          navDrawer.style.removeProperty('--header-height');
          return;
        }

        const headerEl = getHeader();
        const announcementEl = getAnnouncement();
        if (!headerEl) return;
        const headerRect = headerEl.getBoundingClientRect();
        const headerH = Math.round(headerRect.height);
        const announcementH = announcementEl ? Math.round(announcementEl.getBoundingClientRect().height) : 0;
        const totalTop = headerH + announcementH;
        navDrawer.style.left = '0';
        navDrawer.style.right = '0';
        navDrawer.style.width = '100vw';
        navDrawer.style.maxWidth = '100vw';
        navDrawer.style.height = `calc(100vh - ${totalTop}px)`;
        navDrawer.style.setProperty('--header-height', `${totalTop}px`);
        navDrawer.style.setProperty('--single-header-height', `${headerH}px`);
      };

      applyLayout();
      window.addEventListener('resize', applyLayout);
      const headerObserver = new ResizeObserver(applyLayout);
      const headerEl = getHeader();
      if (headerEl) headerObserver.observe(headerEl);
      const announcementEl = getAnnouncement();
      if (announcementEl) headerObserver.observe(announcementEl);

      // Click yg-link-top-cross to close the drawer
      const closeButtons = navDrawer.querySelectorAll('.yg-link-top-cross');
      closeButtons.forEach((closeBtn) => {
        closeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (navDrawer.hide) {
            navDrawer.hide();
          } else {
            navDrawer.removeAttribute('open');
          }
        });
      });

      // Accordion mutual exclusion: when one accordion opens, close all others
      // Also show/hide corresponding yg-navigation-button
      const accordions = navDrawer.querySelectorAll('details[is="accordion-disclosure"]');
      const buttons = navDrawer.querySelectorAll('.yg-navigation-button');
      
      accordions.forEach((accordion) => {
        accordion.addEventListener('toggle', function() {
          if (this.open) {
            // Close other accordions
            accordions.forEach((other) => {
              if (other !== this && other.open) {
                other.open = false;
              }
            });
            
            // Hide all buttons first
            buttons.forEach((btn) => btn.classList.remove('is-active'));
            
            // Find and show the corresponding button
            // Button is the next sibling of the parent <li> that contains this accordion
            const parentLi = this.closest('li');
            if (parentLi && parentLi.nextElementSibling) {
              const nextSibling = parentLi.nextElementSibling;
              if (nextSibling.classList.contains('yg-navigation-button')) {
                nextSibling.classList.add('is-active');
              }
            }
          } else {
            // Hide the corresponding button when accordion closes
            const parentLi = this.closest('li');
            if (parentLi && parentLi.nextElementSibling) {
              const nextSibling = parentLi.nextElementSibling;
              if (nextSibling.classList.contains('yg-navigation-button')) {
                nextSibling.classList.remove('is-active');
              }
            }
          }
        });
      });
    }
  })();

  (function setupAppEmbedMode() {
    const isAppEmbed = window.YG_APP_EMBED === true || document.documentElement.getAttribute('data-app-embed') === 'true';
    const main = document.getElementById('main');
    const getEmbedUrl = (anchor) => {
      if (!anchor || anchor.hasAttribute('download')) return null;

      const rawHref = anchor.getAttribute('href');
      if (!rawHref || rawHref.charAt(0) === '#') return null;

      try {
        const url = new URL(anchor.href, window.location.href);
        if (url.origin !== window.location.origin || ['mailto:', 'tel:', 'javascript:'].includes(url.protocol)) return null;

        url.searchParams.set('app_embed', 'true');
        return url;
      } catch (error) {
        return null;
      }
    };

    if (isAppEmbed && main) {
      main.querySelectorAll('a[href]').forEach((anchor) => {
        const url = getEmbedUrl(anchor);
        if (url) anchor.href = url.toString();
      });

      main.addEventListener('click', (event) => {
        const anchor = event.target.closest('a[href]');
        if (!anchor || !main.contains(anchor)) return;

        const url = getEmbedUrl(anchor);
        if (!url) return;

        anchor.href = url.toString();

        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          (anchor.target && anchor.target !== '_self')
        ) {
          return;
        }

        event.preventDefault();
        window.location.assign(url.toString());
      }, true);
    }

    if (!window.parent || window.parent === window) return;

    let lastHeight = 0;
    let pending = false;

    const postPageHeight = () => {
      pending = false;

      const docEl = document.documentElement;
      const body = document.body;
      const height = Math.ceil(Math.max(
        docEl ? docEl.scrollHeight : 0,
        body ? body.scrollHeight : 0,
        main ? main.scrollHeight : 0
      ));

      if (!height || height === lastHeight) return;

      lastHeight = height;
      window.parent.postMessage({ type: 'ACCUMEMS_EMBED_HEIGHT', height, href: window.location.href }, '*');
    };

    const schedulePostPageHeight = () => {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(postPageHeight);
    };

    schedulePostPageHeight();
    window.addEventListener('load', schedulePostPageHeight);
    window.addEventListener('resize', schedulePostPageHeight);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedulePostPageHeight).catch(() => {});
    }

    if (document.body) {
      new MutationObserver(schedulePostPageHeight).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
    }

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(schedulePostPageHeight);
      if (document.body) resizeObserver.observe(document.body);
      if (main) resizeObserver.observe(main);
    }

    window.addEventListener('message', (event) => {
      const messageType = typeof event.data === 'string' ? event.data : event.data && event.data.type;
      if (messageType === 'ACCUMEMS_REQUEST_EMBED_HEIGHT') schedulePostPageHeight();
    });
  })();

  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.buttons = null;
      this.tabHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll('.yg-collection-tab-item');
      this.items = this.querySelectorAll('.yg-right-box');
      this.buttons = this.querySelectorAll('.yg-collection-tab-item-button');
      if (this.tabs.length === 0 || this.items.length === 0) return;

      // 初始化高亮和展示
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === 0);
        if (this.items[i]) this.items[i].classList.toggle('active', i === 0);
      });
      this.updateViewAllButton(0);

      // 根据屏幕宽度设置事件
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
      this.items.forEach((p, j) => p.classList.toggle('active', index === j));
      this.updateViewAllButton(index);
    }

    updateViewAllButton(activeIndex) {
      if (!this.buttons || this.buttons.length === 0) return;

      this.buttons.forEach((btn, i) => {
        const isActive = i === activeIndex;
        btn.hidden = !isActive;
        btn.classList.toggle('active', isActive);
      });
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.tabHandlers = [];

      // 根据设备类型添加事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          // 移动端：点击切换
          type = 'click';
          handler = () => this.switchTab(i);
        } else {
          // 桌面端：悬浮切换
          type = 'mouseenter';
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  class YGSwiper extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.getAllAttributes()
      this.initSwiper()
    }

    getAllAttributes() {
      let booleanAttrs = ['loop', 'pagination', 'navigation'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        loop: this['loop'],
        autoplay: this['autoplay'] ? {
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        } : false,
        pagination: this['pagination'] ? {
          el: '.swiper-pagination',
          clickable: true,
        } : false,
        navigation: this['navigation'] ? {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        } : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false
      })
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper)
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }
  /* Gallery hover helpers: add class and fine-grained hover behavior for thumbnails/media */
  (function attachGalleryHoverHandlers() {
    const galleries = document.querySelectorAll('.yg-product-gallery');
    if (!galleries || galleries.length === 0) return;

    galleries.forEach((gallery) => {
      // add class on mouse enter/leave to allow CSS-based transitions where :hover may be insufficient
      gallery.addEventListener('mouseenter', () => gallery.classList.add('yg-hovering'));
      gallery.addEventListener('mouseleave', () => gallery.classList.remove('yg-hovering'));

      // Fine-grained hover for thumbnails / page-dots: make hovered item + current media fully opaque
      const thumbSelector = '.product-gallery__thumbnail, .page-dots .tap-area';
      const thumbs = gallery.querySelectorAll(thumbSelector);
      if (!thumbs || thumbs.length === 0) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('mouseenter', () => {
          // thumbnails: hovered one -> 1, others -> 0.5
          thumbs.forEach(t => {
            try { t.style.opacity = (t === thumb) ? '1' : '0.5'; } catch(e) {}
          });

          // media: keep current active at 1, others 0.5
          gallery.querySelectorAll('.product-gallery__media').forEach(m => {
            try { m.style.opacity = m.classList.contains('active') ? '1' : '0.5'; } catch(e) {}
          });
        });

        thumb.addEventListener('mouseleave', () => {
          // remove inline opacity to fall back to CSS rules
          thumbs.forEach(t => { t.style.removeProperty('opacity'); });
          gallery.querySelectorAll('.product-gallery__media').forEach(m => { m.style.removeProperty('opacity'); });
        });
      });
    });
  })();

 
  /* 自定义元素：当视口中存在 .product-info__block-item[data-block-type="button"] 时，隐藏当前 section（或包裹元素） */
  class HideSectionOnButton extends HTMLElement {
    constructor() {
      super();
      this._intersecting = new Set();
      this._io = null;
      this._mo = null;
      this._hostSection = null;
    }

    connectedCallback() {
      // 要隐藏的宿主 section：优先查找 id 以 shopify-section- 开头的祖先，否则使用自身
      this._hostSection = this.closest('[id^="shopify-section-"]') || this;

      // 支持多种可能的 buy 按钮标记：单独的 button block、buy-buttons block 或直接的 buy-buttons 容器
      const selector = '.product-info__block-item[data-block-type="button"], .product-info__block-item[data-block-type="buy-buttons"], .product-info__buy-buttons';

      // IntersectionObserver 回调：维护当前可见集合，依据集合是否为空来添加/移除 class
      this._io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const el = entry.target;
          if (entry.isIntersecting) {
            this._intersecting.add(el);
          } else {
            this._intersecting.delete(el);
          }
        });
        if (this._intersecting.size > 0) {
          this._hostSection.classList.add('yg-hidden-by-button');
        } else {
          this._hostSection.classList.remove('yg-hidden-by-button');
        }
      }, { threshold: 0.01 });

      // 观察当前已有匹配项
      document.querySelectorAll(selector).forEach(el => this._io.observe(el));

      // 观察 DOM 新增节点，自动开始观察新插入的匹配项
      this._mo = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches(selector)) {
              this._io.observe(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll(selector).forEach(n => this._io.observe(n));
            }
          });
        });
      });
      this._mo.observe(document.body, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this._io) {
        this._io.disconnect();
        this._io = null;
      }
      if (this._mo) {
        this._mo.disconnect();
        this._mo = null;
      }
      this._intersecting.clear();
    }
  }

  if (!window.customElements.get('hide-section-on-button')) {
    window.customElements.define('hide-section-on-button', HideSectionOnButton);
  }

});
